import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SearchService} from "../../../services/search.service";
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  selector: 'search-form',
  templateUrl: './search-form.component.html'
})
export class SearchFormComponent implements OnInit {
    public form: FormGroup;
    public suggestions: Object = null;
    private searchTimeout: number = null;
    private blurTimeout: number = null;
    private suggestionLimit = 5;

    constructor(private fb: FormBuilder, private searchService: SearchService, private route: ActivatedRoute, private router: Router) {
        this.form = fb.group({
            query: ''
        });
    }

    ngOnInit() {
    }

    goToItem(suggestion)
    {
        this.router.navigateByUrl(suggestion['url']);
    }

    keyup()
    {
        this.suggestions = null;

        if(this.searchTimeout)
        {
            clearTimeout(this.searchTimeout);
        }

        if(this.form.value.query.length >= 2)
        {
            this.searchTimeout = setTimeout(this.autocomplete.bind(this), 200);
        }
    }
    focus = this.keyup;

    private autocomplete()
    {
        this.searchService.search(this.form.value.query).subscribe((res) => {
            this.setSuggestions(res.data);
        });
    }

    private setSuggestions(data)
    {
        const pattern = new RegExp('(' + this.form.value.query + ')', 'i');

        if(!data['ingredients'])
        {
            data['ingredients'] = [];
        }
        if(data['ingredients'].length > this.suggestionLimit)
        {
            data['ingredients'] = data['ingredients'].slice(0,this.suggestionLimit);
        }
        if(!data['products'])
        {
            data['products'] = [];
        }
        if(data['products'].length > this.suggestionLimit)
        {
            data['products'] = data['products'].slice(0,this.suggestionLimit);
        }

        this.suggestions = data['ingredients'].concat(data['products']).map((suggestion) => {
            const type = suggestion['Ingredienten'] ? 'ingredient' : 'product';
            const name = (suggestion['Ingredienten'] || suggestion['Merk'] + ' ' + suggestion['Subnaam']);
            const slug = encodeURIComponent(name.toLowerCase().replace(' ','-'));
            const url = suggestion['Ingredienten'] ? '/search/' + suggestion['Ingredienten'] : '/product/' + suggestion['id'] + '/' + slug;
            return {
                type,
                id: suggestion['id'],
                name: name.toLowerCase().replace(pattern, '<span class="autocomplete__item__match">$1</span>'),
                slug: slug,
                url: url
            };
        });
    }

    blur()
    {
        this.blurTimeout = setTimeout(()=>{this.suggestions = null},200);
    }

    submit()
    {
        this.router.navigate(['search',this.form.value.query]);
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/_blocks/search-form/search-form.component.ts